module.exports = __webpack_public_path__ + "img/bx-pause.ff8dae59.svg";